export default __webpack_public_path__ + "static/media/creating-contact-list-2.cfa2f0f1.png";